export default __webpack_public_path__ + "static/media/attached-pin.9883f911.svg";